import { ComponentProps, ReactNode } from 'react';
import styled from 'styled-components';
import { Box, Flex } from 'reflexbox';
import { Heading, Paragraph, Subheading } from './Text';

const Card = styled(Flex)`
	border: 1px solid ${(props) => props.theme.colors.lightBlue};
	border-radius: 5px;
	align-items: center;
	justify-content: center;
	padding: 32px 0px;
`;

const Container = styled(Flex)`
	align-items: center;
	flex-direction: column;
	max-width: 280px;
`;

const Icon = styled(Box)<{ small?: boolean }>`
	svg {
		display: block;
		${(props) =>
			props.small
				? `
			width: 32px;
			height: 32px;
		`
				: `
			width: 48px;
			height: 48px;
		`}
	}
`;

export function Empty(props: {
	icon?: ReactNode;
	title?: string;
	description?: string;
	small?: boolean;
	footer?: ReactNode;
}) {
	return (
		<Container>
			{props.icon && <Icon small={props.small}>{props.icon}</Icon>}
			{props.title &&
				(props.small ? (
					<Subheading textAlign="center">{props.title}</Subheading>
				) : (
					<Heading textAlign="center">{props.title}</Heading>
				))}
			{props.description && <Paragraph textAlign="center">{props.description}</Paragraph>}
			{props.footer}
		</Container>
	);
}

function EmptyCard(props: ComponentProps<typeof Empty>) {
	return (
		<Card>
			<Empty {...props} />
		</Card>
	);
}

Empty.Card = EmptyCard;
